<script setup lang="ts">
// Overrides @basecom-gmbh/pond/components/Layout/Header/Search/LayoutHeaderSearchBar.vue
// changes:
// remove search icon, change gap, change order of modules

const configStore = useConfigStore();
const wishlistEnabled = configStore.get('core.cart.wishlistEnabled');

</script>

<template>
    <div class="flex w-[6.875rem] items-center gap-6">
        <LayoutHeaderAccount />

        <LayoutHeaderWishlist v-if="wishlistEnabled" />

        <LayoutHeaderCart />
    </div>
</template>
